import { maxWidth, noTouch } from '@/assets/styles/mixins.css.js';
import { loadableStyles } from '@/assets/styles/global.css';
import styled, {css} from 'styled-components';
import vars from '@/assets/styles/vars';

const StyledWidget = styled.div`
  position: fixed;
  z-index: 2;
  right: 86px;
  bottom: 116px;
  transition: 0.3s ease-out;

  ${maxWidth(vars.breakpoints.tablet)`
    right:24px;
  `}

  ${(props) =>
    props.static &&
    css`
      position: relative;
      right: 0;
      bottom: 0;
    `}
`;

StyledWidget.Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65px;
  height: 65px;
  padding: 0;
  background: var(--color-decor);
  border-radius: 50%;
  border: none;
  cursor: pointer;
  padding:4px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    padding: 9px;
    border: 1px solid #fff;
    border-radius: 50%;
  }

  ${(props) =>
    props.green &&
    css`
      background: #25D366;

      svg {
        border: none;
      }
    `}

  ${maxWidth(vars.breakpoints.tablet)`
    width: 57px;
    height: 57px;
  `}
`;

StyledWidget.Body = styled.div`
  position: absolute;
  right: 50%;
  top: -23px;
  width: calc(100vw - 40px);
  max-width: 358px;
  padding: 35px;
  background: #f8f8f8;
  transform: translateY(-100%);
  filter: drop-shadow(0px 0px 4px #ccc);

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 25px;
    max-width: 339px;
    right: 0;
    top: -18px;
  `}

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(0, 95%);
    display: block;
    width: 11px;
    height: 10px;
    background-image: url("data:image/svg+xml,%3Csvg width='11' height='10' viewBox='0 0 11 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 10V0H0L11 10Z' fill='%23F8F8F8' /%3E%3C/svg%3E");
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  
  ${(props) =>
    props.under &&
    css`
      top:unset;
      bottom: -23px;
      right: 15px;
      transform: translateY(100%);
      
      &::after {
        bottom: unset;
        right: 0;
        top: 0;
        transform: translate(0px, -95%) scaleY(-1);
      }
    `}
`;

StyledWidget.Section = styled.div`
  &:not(:last-child) {
    margin-bottom: 30px;

    ${maxWidth(vars.breakpoints.tablet)`
      margin-bottom: 25px;
     `}
  }
`;

StyledWidget.Title = styled.div`
  margin-bottom: 15px;
  font-size: 14px;
  line-height: 114%;
  color: var(--color-decor);
`;

StyledWidget.Item = styled.a`
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 18px;
  line-height: 120%;
  color: #323232;
  text-decoration: none;
  transition: color 0.3s ease-out;

  &:not(:last-child) {
    margin-bottom: 15px;
  }

  @media (hover: hover) {
    &:hover {
      color: var(--color-decor);
    }
  }
`;

StyledWidget.AppointButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border: 1px solid var(--color-decor);
  border-radius: 90px;
  padding: 11px 24px 13px;
  height: 50px;
  color: var(--color-decor);
  background: transparent;
  font-size: 14px;
  line-height: 171%;
  text-transform: uppercase;
  letter-spacing: -0.1px;
  &::after {
    content: '';
    display: block;
    width: 18px;
    height: 12px;
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='12' viewBox='0 0 18 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.56189 11.562L11.1238 6.00013L5.56189 0.438243' stroke='%23B69B64' /%3E%3Cpath d='M11.2628 11.5615L16.8247 5.99964L11.2628 0.437755' stroke='%23B69B64' /%3E%3C/svg%3E");
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition: 0.3s ease-out;
  }
  &:hover {
    &::after {
      transform: translateX(5px);
    }
  }
`;

export default StyledWidget;
